import Dashboard from './icons/Dashboard';
import CalendarCheckIcon from './icons/CalendarCheckIcon';
import SupportIcon from './icons/SupportIcon';
import LogOutIcon from './icons/LogOutIcon';

export const getDropdownItems = (lang, translations, onLogout) => [
  {
    Icon: Dashboard,
    href: `/${lang}/user/dashboard`,
    text: translations?.account_dashboard_dropdown || 'My Account'
  },
  {
    Icon: CalendarCheckIcon,
    href: `/${lang}/user/bookings`,
    text: translations?.my_bookings || 'Bookings'
  },
  {
    Icon: SupportIcon,
    href: `/${lang}/faqs`,
    text: translations?.mobile_more_support || 'Support'
  },
  {
    Icon: LogOutIcon,
    onClick: onLogout,
    text: translations?.logout || 'Logout'
  }
];
